<div data-cy="modal-component" class="rounded-2.5xl w-full text-center">
  <!-- Header -->
  <div class="px-12 md:px-24 py-6 md:py-12 border-gray-300 border-b">
    <h1 class="text-xl md:text-3xl" [innerHTML]="title()"></h1>
  </div>
  <!-- <hr> -->
  <!-- Body -->
  <div class="px-12 md:px-24 py-6 md:py-12">
    <!-- <h4 class="font-normal">{{ content }}</h4> -->
    <h4 class="font-normal" [innerHTML]="content()"></h4>
    <div class="flex justify-center mt-6 md:mt-12">
      @if (closeBtnName()) {
        <sdc-button
          class="gs-modal-btn--outline"
          className="disabled:opacity-30 mr-3 md:mr-6 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
          data-cy="modal-cancel-button"
          theme="theme-sdc"
          variant="outline"
          (onClick)="close()">
          {{ closeBtnName() }}
        </sdc-button>
      }
      @if (acceptBtnName()) {
        <sdc-button
          class="gs-modal-btn--primary"
          className="disabled:opacity-30 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
          data-cy="modal-accept-button"
          theme="theme-sdc"
          variant="primary"
          (onClick)="accept()">
          {{ acceptBtnName() }}
        </sdc-button>
      }
    </div>
    @if (showProvenueErrorInfo) {
      <div class="flex flex-col items-start gap-4 mt-6">
        <p>
          <strong>PV Request ID:</strong>
          {{ provenueErrorService.getPvRequestId() || 'Unknown' }}
        </p>
        <p>
          <strong>PV Proxy Request ID:</strong>
          {{ provenueErrorService.getPvProxyRequestId() || 'Unknown' }}
        </p>
      </div>
    }
  </div>
</div>
